export const stripeSubscriptionCancel = {
	alert1: "{0} Nous sommes très tristes de vous voir quitter l’aventure Osteo2ls. Votre retour est essentiel pour nous aider à améliorer nos services et mieux répondre aux attentes des ostéopathes.",
    alert2 : "{0} En confirmant, vous validez la résiliation de votre abonnement.",
	other : {
		label: "Pouvez-vous préciser ?",
		placeholder: "Précisez ici...",
		title: ""
	},
	question: 'Quelle est la raison principale de votre désabonnement ?',
	reasons : {
		"business-change": "Changement de modèle économique / abonnement",
		"too-expensive": "Trop cher",
		"missing-features": "Manque de fonctionnalités",
		"bugs-or-slowness": "Bugs ou lenteurs",
		"switch-software": "Je change de logiciel",
		"no-activity": "Je n’exerce plus / pause d’activité",
		"trust-issues": "Problème de confiance ou relation client",
		"other": "Autre"
	},
	'maxLength-warning': "Attention : le texte ne peut pas dépasser {0} caractères."
}
